import React, { Component } from "react";
import Fade from "react-reveal/Fade";

import SectionTitle from "../SectionTitle/SectionTitle";
import "./About.css";

export default class About extends Component {
  render() {
    return (
      <section id="about" className="section">
        <Fade duration={1000} delay={200}>
          <SectionTitle>عن الأكاديمية </SectionTitle>
        </Fade>

        <div className="container">
          <div className="columns">
            <Fade duration={1000} delay={200}>
              <div className="column mt-3">
                <p className="about-header has-text-centered">
                  أكاديمية الحكومة الرقمية هي أكاديمية متخصصة في تطوير المهارات
                  القيادية والفنية للعاملين في مجال التحول الرقمي الحكومي
                  بالمملكة العربية السعودية، وتتبع لبرنامج التعاملات الالكترونية
                  الحكومية (يسّر).
                </p>
              </div>
            </Fade>
          </div>

          <div className="columns mt-5">
            <Fade duration={1000} delay={200}>
              <div className="column">
                <div className="about colmuns ">
                  <h3 className="title">التطوير وعمليات التعليم</h3>

                  <div className="about box">
                    <ul className="mt-0.5">
                      <li>
                        {" "}
                        بناء وتطوير البرامج التدريبية بناء على الاحتياج الخاص
                        بالأكاديمية.
                      </li>
                      <li> دعم تقييم المخرجات الخاصة بالبرامج التطويرية.</li>
                      <li>
                        {" "}
                        متابعة المخرجات الخاصة بالبرامج ومدى تحقيقها للأهداف
                        التدريبية.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade duration={1000} delay={200}>
              <div className="column mb-2">
                <div className="about colmuns">
                  <h3 className="title">الأبحاث والجوائز</h3>
                  <div className="about box">
                    <ul className="mt-2">
                      <li>
                        {" "}
                        إصدار عدد من الأبحاث ودراسة حالات لقصص النجاح المحلية في
                        مجال التحول الرقمي.{" "}
                      </li>
                      <li> عقد ندوات لمتحدثين في مجال التحول الرقمي.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </section>
    );
  }
}
